export const CurtainsTypes = [
    {value: 'kurtyna rolowana CE', label: 'kurtyna rolowana CE'},
    {value: 'kurtyna opadająca FS', label: 'kurtyna opadająca FS'},
    {value: 'inne', label: 'inne'},
];

export default CurtainsTypes;